module.exports = __webpack_public_path__ + "static/img/brand_tree.96e1f574.png";